import * as React from 'react';

export type ModalParentNodeRef = HTMLElement;

const context = React.createContext<ModalParentNodeRef>(undefined);
export const ModalParentNodeRefProvider = context.Provider;
export const ModalParentNodeRefConsumer = context.Consumer;
export default context;
